import React from 'react';
import { parseMessageLinks } from '../../utils/linkParser';
import ClickableLink from './ClickableLink';

export function withDisplayMentions(message, people) {
    if (!message || typeof message !== "string" || !people?.length) return message;
    return message.replace(/@([^\s@]+@[^\s@]+)/g, (full, name) => {
        const person = people.find((item) => item.username === name);
        return person?.display_name ? `@${person.display_name}` : full;
    });
}

const MessageWithLinks = ({ message }) => {
    if (!message || typeof message !== 'string') {
        return <span>{ message }</span>;
    }

    const parts = parseMessageLinks(message);

    return (
        <span>
            { parts.map((part, index) => {
                if (part.type === 'link') {
                    return (
                        <ClickableLink
                            key={ index }
                            entityType={ part.entityType }
                            entityId={ part.entityId }
                            content={ part.content }
                        />
                    );
                } else {
                    return <span key={ index }>{ part.content }</span>;
                }
            }) }
        </span>
    );
};

export default MessageWithLinks;
